import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookmarkIcon, CalendarIcon, FileTextIcon, ShoppingBagIcon, BellIcon, MessageCircleIcon, ThumbsUpIcon, ChevronRightIcon, SettingsIcon, LogOutIcon, PencilIcon, MessageSquareIcon } from 'lucide-react';
import { toast } from 'sonner';
import { BottomSheet } from '../components/common/BottomSheet';
import { MiniTopBar } from '../components/common/MiniTopBar';
const tagDims: Record<string, string[]> = {
  国家: ['英国', '美国', '中国香港', '新加坡', '澳大利亚', '加拿大'],
  学历: ['本科', '硕士', '博士'],
  专业: ['计算机', '商科', '工程', '艺术', '社科'],
  时间线: ['2026 春', '2026 秋', '2027 春', '2027 秋']
};
const services = [{
  i: BookmarkIcon,
  t: '我的收藏',
  n: 8,
  to: '/mine/favorites'
}, {
  i: CalendarIcon,
  t: '我的预约',
  n: 2,
  to: '/mine/appointments'
}, {
  i: FileTextIcon,
  t: '我的AI报告',
  n: 1,
  to: '/mine/reports'
}, {
  i: ShoppingBagIcon,
  t: '我的订单',
  n: 0,
  to: '/mine/orders'
}];
export function Mine() {
  const nav = useNavigate();
  const [logged, setLogged] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [tags, setTags] = useState<string[]>(['英国', '硕士', '计算机', '2026 秋']);
  const toggle = (t: string) => {
    setTags(tags.includes(t) ? tags.filter(x => x !== t) : [...tags, t]);
  };
  return <div className="bg-slate-50 min-h-screen pb-20" data-id="element-458">
      <MiniTopBar title="我的" data-id="element-459" />

      {/* 个人信息 */}
      <div className="px-4 pt-4 pb-12 text-white relative" style={{
      background: 'linear-gradient(135deg,#2b6ef5,#5a93ff)'
    }} data-id="element-460">
        {logged ? <>
            <div className="flex items-center gap-3" data-id="element-461">
              <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120" alt="" className="w-14 h-14 rounded-full object-cover border-2 border-white/40" data-id="element-462" />
              <div className="flex-1 min-w-0" data-id="element-463">
                <div className="font-bold text-lg" data-id="element-464">同学你好</div>
                <div className="text-xs opacity-90 mt-0.5" data-id="element-465">
                  编辑资料完善留学意向 →
                </div>
              </div>
              <button onClick={() => setEditing(true)} className="bg-white/20 backdrop-blur rounded-full px-3 py-1.5 text-xs flex items-center gap-1" data-id="element-466">
                <PencilIcon size={12} data-id="element-467" /> 编辑标签
              </button>
            </div>
            <div className="flex flex-wrap gap-1.5 mt-3" data-id="element-468">
              {tags.length === 0 && <span className="text-xs opacity-80" data-id="element-469">暂未设置意向标签</span>}
              {tags.map(t => <span key={t} className="bg-white/20 text-white text-xs px-2 py-1 rounded-full" data-id="element-470">
                  {t}
                </span>)}
            </div>
          </> : <div className="flex items-center gap-3 py-2" data-id="element-471">
            <div className="w-14 h-14 rounded-full bg-white/20 border-2 border-white/40 flex items-center justify-center" data-id="element-472">
              <MessageSquareIcon size={24} className="text-white/80" data-id="element-473" />
            </div>
            <div className="flex-1" data-id="element-474">
              <div className="font-bold text-lg" data-id="element-475">未登录</div>
              <div className="text-xs opacity-90 mt-0.5" data-id="element-476">
                登录后体验完整功能
              </div>
            </div>
            <button onClick={() => setAuthOpen(true)} className="bg-white text-blue-600 font-bold rounded-full px-4 py-2 text-sm shadow-sm" data-id="element-477">
              微信一键登录
            </button>
          </div>}
      </div>

      {/* 服务记录 */}
      <div className="mx-3 -mt-7 bg-white rounded-2xl p-4 shadow-sm relative z-10" data-id="element-478">
        <div className="grid grid-cols-4 gap-2" data-id="element-479">
          {services.map(s => {
          const Icon = s.i;
          return <button key={s.t} onClick={() => logged ? nav(s.to) : setAuthOpen(true)} className="flex flex-col items-center gap-1.5" data-id="element-480">
                <div className="w-11 h-11 rounded-2xl bg-blue-50 flex items-center justify-center relative" data-id="element-481">
                  <Icon size={20} className="text-blue-600" data-id="element-482" />
                  {logged && s.n > 0 && <span className="absolute -top-1 -right-1 bg-rose-500 text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center" data-id="element-483">
                      {s.n}
                    </span>}
                </div>
                <span className="text-[11px] text-slate-700" data-id="element-484">{s.t}</span>
              </button>;
        })}
        </div>
      </div>

      {/* 关于指南者留学 */}
      <div className="mx-3 mt-3 bg-white rounded-2xl p-4" data-id="element-485">
        <div className="font-bold text-slate-800 mb-3 flex items-center gap-2" data-id="element-486">
          <span className="w-1 h-4 bg-blue-500 rounded" data-id="element-487" /> 关于指南者留学
        </div>
        <div className="grid grid-cols-3 text-center" data-id="element-488">
          {[{
          v: '36820',
          l: '收获 offer'
        }, {
          v: '1170496',
          l: '注册用户'
        }, {
          v: '19223',
          l: '服务学员'
        }].map(s => <div key={s.l} data-id="element-489">
              <div className="text-blue-600 font-extrabold" data-id="element-490">{s.v}</div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-491">{s.l}</div>
            </div>)}
        </div>
        <p className="text-xs text-slate-500 leading-relaxed mt-3" data-id="element-492">
          指南者留学，专注海外名校申请，三对一服务体系，让留学链接多元人生。
        </p>
      </div>

      <MenuGroup title="功能入口" items={[{
      i: BellIcon,
      t: '消息通知',
      badge: logged ? 3 : 0,
      onClick: () => logged ? nav('/mine/notifications') : setAuthOpen(true)
    }, {
      i: MessageCircleIcon,
      t: '在线客服',
      onClick: () => toast('客服已接入')
    }, {
      i: ThumbsUpIcon,
      t: '意见反馈',
      onClick: () => toast('反馈功能开发中')
    }]} data-id="element-493" />

      <MenuGroup title="设置中心" items={[{
      i: SettingsIcon,
      t: '用户协议',
      onClick: () => toast('查看协议')
    }, {
      i: SettingsIcon,
      t: '隐私政策',
      onClick: () => toast('查看政策')
    }, ...(logged ? [{
      i: LogOutIcon,
      t: '退出登录',
      danger: true,
      onClick: () => setLogged(false)
    }] : [])]} data-id="element-494" />

      {/* 编辑标签 */}
      <BottomSheet open={editing} onClose={() => setEditing(false)} title="编辑留学意向标签" data-id="element-495">
        <div className="p-4 space-y-4" data-id="element-496">
          {Object.entries(tagDims).map(([k, opts]) => <div key={k} data-id="element-497">
              <div className="text-sm font-semibold text-slate-800 mb-2" data-id="element-498">
                {k}
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-499">
                {opts.map(o => {
              const sel = tags.includes(o);
              return <button key={o} onClick={() => toggle(o)} className={`px-3 py-1.5 rounded-full text-xs border transition ${sel ? 'bg-blue-600 text-white border-blue-600' : 'bg-slate-50 text-slate-700 border-slate-200'}`} data-id="element-500">
                      {o}
                    </button>;
            })}
              </div>
            </div>)}
        </div>
        <div className="sticky bottom-0 bg-white border-t border-slate-100 p-3" data-id="element-501">
          <button onClick={() => {
          setEditing(false);
          toast.success('意向标签已保存');
        }} className="w-full h-11 rounded-full bg-blue-600 text-white font-semibold text-sm" data-id="element-502">
            保存
          </button>
        </div>
      </BottomSheet>

      {/* 微信授权 */}
      <BottomSheet open={authOpen} onClose={() => setAuthOpen(false)} title="微信授权登录" data-id="element-503">
        <div className="p-6 flex flex-col items-center text-center" data-id="element-504">
          <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center text-white font-bold text-2xl mb-4" data-id="element-505">
            留
          </div>
          <div className="font-bold text-lg text-slate-800 mb-1" data-id="element-506">留学行</div>
          <div className="text-sm text-slate-500 mb-8" data-id="element-507">
            申请获取你的公开信息（昵称、头像等）
          </div>
          <button onClick={() => {
          setLogged(true);
          setAuthOpen(false);
          toast.success('登录成功');
        }} className="w-full h-12 rounded-full bg-[#07C160] text-white font-bold text-base mb-3" data-id="element-508">
            允许授权
          </button>
          <button onClick={() => setAuthOpen(false)} className="w-full h-12 rounded-full bg-slate-100 text-slate-600 font-bold text-base" data-id="element-509">
            拒绝
          </button>
        </div>
      </BottomSheet>
    </div>;
}
function MenuGroup({
  title,
  items
}: {
  title: string;
  items: {
    i: any;
    t: string;
    badge?: number;
    danger?: boolean;
    onClick: () => void;
  }[];
}) {
  return <div className="mx-3 mt-3 bg-white rounded-2xl overflow-hidden" data-id="element-510">
      <div className="px-4 pt-3 pb-1 text-xs text-slate-500 font-medium" data-id="element-511">
        {title}
      </div>
      {items.map((it, idx) => {
      const Icon = it.i;
      return <button key={it.t} onClick={it.onClick} className={`w-full flex items-center gap-3 px-4 py-3 active:bg-slate-50 ${idx !== items.length - 1 ? 'border-b border-slate-50' : ''}`} data-id="element-512">
            <Icon size={18} className={it.danger ? 'text-rose-500' : 'text-blue-600'} data-id="element-513" />
            <span className={`flex-1 text-left text-sm ${it.danger ? 'text-rose-500' : 'text-slate-800'}`} data-id="element-514">
              {it.t}
            </span>
            {it.badge ? <span className="bg-rose-500 text-white text-[10px] rounded-full px-1.5 min-w-4 h-4 flex items-center justify-center" data-id="element-515">
                {it.badge}
              </span> : null}
            <ChevronRightIcon size={16} className="text-slate-400" data-id="element-516" />
          </button>;
    })}
    </div>;
}